/**
 * Checks if `value` is greater than `other`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
 * @example
 *
 * _.gt(3, 1);
 * // => true
 *
 * _.gt(3, 3);
 * // => false
 *
 * _.gt(1, 3);
 * // => false
 */
function gt(value, other) {
  return value > other;
}

module.exports = gt;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/gt.js
 ** module id = 1396
 ** module chunks = 0
 **/